'use memo'

import css from '@emotion/css/macro'
import appColors from '@sportninja/common/constants/appColors'

const colors = appColors as Record<string, string>
import {
  font,
  weightBold,
  weightRegular,
  paragraphSmall,
  paragraphXSmall,
  paragraphMedium,
} from '../../../../components/css'

export const containerStyle = css`
  background-color: ${colors.SECONDARY_350};
  border: 1px solid ${colors.SECONDARY_300};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const headerSectionStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const headerRowStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`

export const headerTitleStyle = css`
  ${font.body};
  ${weightBold};
  ${paragraphMedium};
  color: ${colors.WHITE};
  display: flex;
  align-items: center;
  gap: 8px;
`

export const headerLinkStyle = css`
  ${font.body};
  ${weightRegular};
  ${paragraphXSmall};
  color: ${colors.PRIMARY};
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  white-space: nowrap;
`

export const headerDividerStyle = css`
  width: 100%;
  height: 1px;
  background-color: ${colors.SECONDARY_300};
`

export const cardRowStyle = css`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: flex-start;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const CARD_GAP_PX = 16

export const cardStyle = (itemCount: number) => {
  const threeUpBasis = `calc((100% - ${2 * CARD_GAP_PX}px) / 3)`
  const flexBasis =
    itemCount <= 3 ? threeUpBasis : `calc((100% - ${3 * CARD_GAP_PX}px) / 3.3)`

  return css`
    flex: 0 0 ${flexBasis};
    min-width: 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;

    &:hover [data-card-thumbnail],
    &:focus-visible [data-card-thumbnail] {
      border-color: ${colors.PRIMARY};
    }

    &:hover [data-play-overlay],
    &:focus-visible [data-play-overlay] {
      opacity: 1;
    }

    &:hover [data-card-title],
    &:focus-visible [data-card-title] {
      color: ${colors.PRIMARY};
    }
  `
}

export const cardThumbnailStyle = css`
  position: relative;
  width: 100%;
  aspect-ratio: 441 / 248;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${colors.SECONDARY_400};
  border: 2px solid transparent;
  transition: border-color 0.15s ease-in-out;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`

export const cardThumbnailActiveStyle = css`
  border-color: ${colors.PRIMARY};
`

export const playOverlayStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
`

export const playOverlayVisibleStyle = css`
  opacity: 1;
`

export const cardTextContainerStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const teamsRowStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const teamsRowLinkStyle = css`
  width: fit-content;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    text-decoration: none;
    outline: none;
  }
`

export const teamAbbrStyle = css`
  ${font.body};
  ${weightBold};
  ${paragraphMedium};
  color: ${colors.WHITE};
`

export const teamLogoStyle = css`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background-color: ${colors.SECONDARY_400};
`

export const vsLabelStyle = css`
  ${font.body};
  ${weightRegular};
  ${paragraphXSmall};
  color: ${colors.NEUTRAL_50};
`

export const cardTitleStyle = css`
  ${font.body};
  ${weightBold};
  ${paragraphSmall};
  color: ${colors.WHITE};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  transition: color 0.15s ease-in-out;
`

export const cardTitleActiveStyle = css`
  color: ${colors.PRIMARY};
`

export const cardDateStyle = css`
  ${font.body};
  ${weightRegular};
  ${paragraphXSmall};
  color: ${colors.NEUTRAL_50};
`
